export const funFactsData = [
  {
    front: "Zach's favorite sport",
    back: "Formula 1. I have been a Max Verstappen fan since 2018 and root for Red Bull Racing every race.",
  },
  {
    front: "Zach's favorite type of game",
    back: "Turn-based strategy. I will happily lose hours to games like Civ VI or Fire Emblem.",
  },
  {
    front: "Zach's favorite part about working at Netgain",
    back: "The culture, and getting to work alongside some of the most intelligent developers in the industry.",
  },
  {
    front: "Zach's hobbies",
    back: "I enjoy learning new programming languages. In my free time I play Magic: The Gathering, run a Dungeons & Dragons campaign for friends, fish, and visit amusement parks.",
  },
];
